import React, { Component } from "react";
import PropTypes from "prop-types";
import cn from "classnames";

class TextArea extends Component {
  constructor(props) {
    super(props);

    this.state = {
      wordsCount: 0
    };
  }

  componentDidMount() {
    this.initState();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { id } = this.props;

    if (prevProps.id !== id) {
      this.initState();
    }
  }

  initState = () => {
    const { value, maxWords, minWords } = this.props;

    const wordsCount = this.getCountOfWords(value);

    const isInputFull = wordsCount > maxWords;
    const isInputLess = wordsCount < minWords;
    const hasError = isInputLess || isInputFull;

    this.setState(() => ({
      value,
      isInputLess,
      isInputFull,
      hasError,
      wordsCount
    }));
  };

  getCountOfWords = str => {
    str = str.replace(/(^\s*)|(\s*$)/gi, "");
    str = str.replace(/[ ]{2,}/gi, " ");
    str = str.replace(/\n /, "\n");

    return str.split(" ").filter(w => w !== "").length;
  };

  getErrorMessage = () => {
    const { isInputFull } = this.state;
    const { maxWords, minWords } = this.props;

    if (isInputFull) {
      return `You’ve exceeded the ${maxWords} word limit`;
    } else {
      return `A minimum of ${minWords} words are required in order to move forward`;
    }
  };

  handleInputChange = e => {
    const { id, maxWords, minWords, onChange, feedback, readonlyMode } = this.props;
    if (readonlyMode) {
      return;
    }

    const inputValue = e.target.value;
    const wordsCount = this.getCountOfWords(inputValue);

    const isInputFull = wordsCount > maxWords;
    const isInputLess = wordsCount < minWords;
    const hasError = isInputLess || isInputFull;

    if (onChange)
      onChange({
        id: id,
        value: inputValue,
        type: "text",
        hasError: hasError,
        feedback: feedback,
      });

    this.setState(() => ({
      wordsCount,
      isInputFull,
      isInputLess,
      hasError,
      value: inputValue
    }));
  };

  render() {
    const { value, wordsCount, isInputFull, hasError } = this.state;
    const { id, title, maxWords, placeholder, showError, text, readonlyMode, leftExtraInfo } = this.props;

    return (
      <div className="peerEvaluationTextArea">
        {title && (
          <h5
            className="title"
            dangerouslySetInnerHTML={
              { __html: title }
            } />
        )}
        <div className="maxWords">{`(${maxWords} words maximum)`}</div>
        {text}
        <div className={`textarea-container ${leftExtraInfo && 'textarea-container--wide'}`}>
          {
            leftExtraInfo &&
            leftExtraInfo
          }
          <textarea
            id={id}
            name={id}
            value={value}
            placeholder={placeholder}
            onChange={this.handleInputChange}
            readOnly={readonlyMode}
            className={cn({ nofocus: readonlyMode })}
          />
        </div>
        <div className="footer">
          {showError && hasError && (
            <div className="errorMessage">{this.getErrorMessage()}</div>
          )}
          <div className={"wordsCount"}>
            <span className={cn({ wordsCount_full: isInputFull })}>
              {wordsCount}
            </span>
            /{maxWords}
          </div>
        </div>
      </div>
    );
  }
}

TextArea.defaultProps = {
  maxWords: 200,
  minWords: 10,
  placeholder: "Type your thoughts here...",
  value: "",
  text: null
};

TextArea.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  maxWords: PropTypes.number,
  minWords: PropTypes.number,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  feedback: PropTypes.number,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf([null]),
  ]),
  readonlyMode: PropTypes.bool,
};

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/peer-evaluation/text-area/index.js